import React, { useEffect, useState } from 'react';
import ModalFormProfile from '../../components/forms/users/modal.form.profiles';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListProfiles() {
  const [msgGet, setMsgGet] = useState('');
  const [Profiles, setProfiles] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getProfiles();
  }, []);

  const createProfile = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getProfiles()
  };

  const editButton = (row) => {
    return (
      <ModalFormProfile
        title="Modificar Perfil"
        button_text="Editar"
        button_variant="outline-primary"
        profileSelect={row.id}
        callback={createProfile}
      ></ModalFormProfile>
    );
  };

  const getProfiles = async () => {
    const responseProfile = await get('/profile/', {})
    if (responseProfile.success) {
      setProfiles(responseProfile.data);
    } else {
      setMsgGet(responseProfile.message)
    }
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
      <ModalFormProfile
        title="Crear Perfil"
        button_text="Crear Perfil"
        button_variant="primary"
        callback={createProfile}
      ></ModalFormProfile>
      <ListTables
        data={Profiles}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListProfiles;
